import { Alert, Box, Button, CircularProgress, styled } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { useIndexPage } from '@/hooks/useIndexPage';

const CenteredContainer = styled(Box)({
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

// Every flag reads as off until the tenant's flags arrive, so redirecting any sooner
// would bounce a user who does have the page on a reload or a bookmark. A failed request
// reads the same way, so it keeps the user where they are rather than sending them away.
export const IndexPageRedirect = () => {
  const { areFeatureFlagsLoaded, didFeatureFlagsFail, retryFeatureFlags } = useFeatureFlags();
  const { indexPagePath } = useIndexPage();

  if (didFeatureFlagsFail) {
    return (
      <CenteredContainer>
        <Alert
          severity='error'
          action={
            <Button color='inherit' size='small' onClick={retryFeatureFlags}>
              Retry
            </Button>
          }
        >
          Couldn&apos;t load this page.
        </Alert>
      </CenteredContainer>
    );
  }

  if (!areFeatureFlagsLoaded) {
    return (
      <CenteredContainer>
        <CircularProgress />
      </CenteredContainer>
    );
  }

  return <Navigate to={indexPagePath} replace />;
};
